import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateVideoPlayerCommentBuckets } from 'actions/videoPlayer';
import { fetchCommentsCreator } from 'creators/comments';

import { selectVideoDuration } from 'selectors/videoPlayer';

import { getBuckets } from '../../../utilities/commentBuckets';

const CommentFetch = props => {
  const comments = useSelector(state => state.comments);
  const dispatch = useDispatch();
  const videoLength = useSelector(selectVideoDuration);

  useEffect(() => {
    if (!comments.has_fetched && !comments.is_fetching) {
      dispatch(fetchCommentsCreator());
    }

    if (comments.comments) {
      dispatch(
        updateVideoPlayerCommentBuckets(
          getBuckets(comments.comments, videoLength)
        )
      );
    }
  }, [
    comments.comments,
    comments.has_fetched,
    comments.is_fetching,
    dispatch,
    videoLength,
  ]);

  return comments.has_fetched && props.children ? props.children : null;
};

export default CommentFetch;
